import React from 'react';

import styles from "./style/message.module.scss";

export default function Message({ message, style }) {
    return (message &&
        <div className={styles[message.text ? "message-open" : "message-close"]} style={style}>
            <span className={styles[message.type ? "success-text" : "error-text"]}>
                {message.text}
            </span>
        </div>
    );
}
